import { RunProse } from './RunProse';

/**
 * The name of a fact, in the column a reader scans down.
 *
 * A lead is either a phrase the agent wrote ("Why green", "Rollup") or the thing the fact is about,
 * named by reference — `[objective:68] Increase Digital Revenue`. Both have to arrive as something
 * readable: an unresolved token is the raw contract leaking onto the page, and the name printed twice
 * is the same column said twice.
 *
 * Linked rather than chipped, unlike the statement beside it: a badge in a 10rem column wraps onto
 * three lines and turns a name into a shape. The link is the same destination the chip would go to.
 */
export const ReferenceLead = ({ children }: { children: string }) => (
  <RunProse references="link">{children}</RunProse>
);
